/** Utilidades monetárias. Regra: dinheiro é sempre inteiro em centavos. */

export function centsToBRL(cents: number): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
}

export function centsToNumber(cents: number): number {
  return Math.round(cents) / 100;
}

export function brlToCents(value: number | string): number {
  const n = typeof value === 'string' ? Number(value.replace(/\./g, '').replace(',', '.')) : value;
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100);
}

/** Meta e Google trabalham em micros (1 unidade = 1.000.000 micros). */
export function centsToMicros(cents: number): number {
  return Math.round(cents * 10_000);
}

export function microsToCents(micros: number): number {
  return Math.round(micros / 10_000);
}

/** Meta recebe budget na menor unidade da moeda (centavos, para BRL). */
export function centsToMetaAmount(cents: number): string {
  return String(Math.round(cents));
}

export function formatPercent(value: number, digits = 2): string {
  return `${value.toFixed(digits).replace('.', ',')}%`;
}

export function monthlyToDailyCents(monthlyCents: number, daysInMonth = 30): number {
  return Math.max(1, Math.round(monthlyCents / daysInMonth));
}

export function pctChange(current: number, previous: number): number {
  if (previous === 0) return current === 0 ? 0 : 100;
  return ((current - previous) / previous) * 100;
}
